/**
 * denyUrls: A list of strings or regex patterns that match error URLs that should not be sent to Sentry. Errors whose
 entire file URL contains (string) or matches (regex) at least one entry in the list will not be sent. As a result,
 if you add 'foo.com' to the list, it will also match on https://bar.com/myfile/foo.com. By default, all errors are sent.
 * https://docs.sentry.io/platforms/react-native/configuration/options/#deny-urls
 */
export const IGNORE_URLS_LIST = [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
];
